import { render, staticRenderFns } from "./CompanyFilesGrid.vue?vue&type=template&id=1d1ff70c&scoped=true&"
import script from "./CompanyFilesGrid.vue?vue&type=script&lang=js&"
export * from "./CompanyFilesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1ff70c",
  null
  
)

export default component.exports